import React from "react";

export const DisplayDataComponent = ({ name, value, link, email }) => {
  return value ? (
    <div className={"mb-3 flex px-2 py-1 rounded-md flex-1 odd:bg-white even:bg-gray-100"}>
      <p className="w-[150px] font-medium">{name}</p>
      <p className="font-medium mr-4">:</p>
      <div className="w-8/12 break-words">
        {email ? (
          <a
            target="_blank"
            rel="noreferrer"
            className="text-sky-600"
            href={"mailto:" + value}
          >
            {value}
          </a>
        ) : link ? (
          <a
            target="_blank"
            rel="noreferrer"
            className="text-sky-600"
            href={value}
          >
            {value}
          </a>
        ) : (
          <p>{value}</p>
        )}
      </div>
    </div>
  ) : (
    <></>
  );
};
